import { GridColDef } from '@mui/x-data-grid-pro';
import { formatDate, formatDateTime } from '../../../utilities';

export const registrationCounterColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Navn',
    flex: 1,
  },
  {
    field: 'externalReference',
    headerName: 'Ekstern reference',
    flex: 1,
  },
  {
    field: 'companyName',
    headerName: 'Virksomhed',
    flex: 1,
  },
  {
    field: 'pUnit',
    headerName: 'P-enhed',
    flex: 1,
  },
  {
    field: 'isActivated',
    headerName: 'Aktiveret',
    valueGetter: ({ value }) => (value ? 'Ja' : 'Nej'),
  },
  {
    field: 'lastRegistration',
    headerName: 'Sidste registrering',
    flex: 1,
    renderCell: ({ value }) => formatDate(value),
  },
  {
    field: 'rejectedRegistrations',
    headerName: 'Afviste registreringer',
    flex: 1,
  },
  {
    field: 'acceptedRegistrations',
    headerName: 'Accepterede registreringer',
    flex: 1,
  },
  {
    field: 'lastOnline',
    headerName: 'Sidst online',
    flex: 1,
    renderCell: ({ value }) => formatDateTime(value),
  },
  {
    field: 'createdBy',
    headerName: 'Oprettet af',
    flex: 1,
  },
  {
    field: 'createdOn',
    headerName: 'Oprettet tidspunkt',
    flex: 1,
    renderCell: ({ value }) => formatDateTime(value),
  },
];
